import React, { useState, useEffect } from "react";
import classnames from "classnames";
import { withStyles } from "components/common";
import Table from "components/common/Table";
import TableFilter from "components/common/TableFilter";
import NoteEditor from "./NoteEditor";

const moment = require("moment");

const computeColumns = ({
  setRowExpanded,
  setRowInfo,
  updateToNotes,
  removeFromNotes,
}) => [
  {
    Header: "Date",
    accessor: (data) => (
      <div className="whitespace-nowrap align-top">
        {moment(parseInt(data.created_at)).format("MM-DD-YYYY")}
      </div>
    ),
    style: { verticalAlign: "top" },
  },
  {
    Header: "Agent",
    accessor: (data) => (
      <div className="whitespace-nowrap align-top">{data.agent_name}</div>
    ),
    style: { verticalAlign: "top" },
  },
  {
    Header: "Body",
    accessor: "body_text",
    Cell: (cell) => {
      const {
        row,
        row: {
          original: { body_text, expanded, tags },
        },
      } = cell;

      return (
        <table className="tomo-table text-left" style={{ tableLayout: "fixed" }}>
          <tbody style={{ boxShadow: "none" }}>
            <tr className="flex p-0">
              <td className="truncate flex-1 p-0">
                <div>
                  {expanded ? (
                    ""
                  ) : (
                    <div className="flex justify-between">
                      <div className="truncate mr-5">{body_text}</div>
                      <div>
                        {tags.map((t, idx) => (
                          <span
                            key={idx}
                            className="py-1 px-2 mr-2 bg-gray-600 text-white"
                          >
                            {t}
                          </span>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
                <div className="whitespace-normal">
                  {expanded && (
                    <NoteEditor
                      note={row.original}
                      updateToNotes={updateToNotes}
                      removeFromNotes={removeFromNotes}
                    />
                  )}
                </div>
              </td>
              <td className="ml-2 p-0" style={{ width: "90px" }}>
                <div className="flex items-center justify-between">
                  <div className="rounded-full w-3 h-3" />
                  <div
                    className="underline"
                    onClick={() => {
                      setRowInfo(row);
                      setRowExpanded(!expanded);
                    }}
                  >
                    {expanded ? "less" : "more"}
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      );
    },
  },
];

const parseNote = (el) => {
  return {
    ...el,
    tags: JSON.parse((el.tags || "{}")).tags,
    body: JSON.parse((el.body || "{}")).text,
  };
};

const NotesTable = ({ notesData, userId }) => {
  const [rowInfo, setRowInfo] = useState();
  const [rowExpanded, setRowExpanded] = useState();
  const [showEditor, setShowEditor] = useState(false);
  const parsedNotes = (notesData || [])
    .map((el) => parseNote(el))
    .sort((a, b) => a.created_at - b.created_at);
  const [notes, setNotes] = useState(parsedNotes);
  const [filteredNotes, setfilteredNotes] = useState(notes);

  const generateTags = () => {
    // console.dir(notes)
    const allTags = notes.reduce((ac, el) => {
      for (const t of el.tags) { ac[t] = (ac[t] || 0) + 1; }
      return ac;
    }, {});

    const tagList = Object.keys(allTags)
      .sort((a, b) => allTags[b] - allTags[a])
      .slice(0, 4);

    const newMapping = {};

    newMapping.all = {
      name: "All",
      fn: () => setfilteredNotes(notes),
    };

    for (const t of tagList) {
      newMapping[t] = {
        name: t,
        fn: () => setfilteredNotes(notes.filter((n) => n.tags.indexOf(t) !== -1)),
      };
    }

    return newMapping;
  };

  const [mapping, setMapping] = useState(generateTags());

  useEffect(() => {
    setfilteredNotes(notes);
    setMapping(generateTags());
  }, [notes]);

  const appendToNotes = (newNote) => {
    setNotes((prevState) => [...prevState, newNote]
      .sort((a, b) => a.created_at - b.created_at),
    );
  };

  const updateToNotes = (data) => {
    const newNote = Object.assign(notes.filter((el) => el.id === data.id)[0], data);
    setNotes((prevState) =>
      [...prevState.filter((el) => el.id !== data.id), newNote]
        .sort((a, b) => a.created_at - b.created_at),
    );
    setRowExpanded(false);
  };

  const removeFromNotes = (id) => {
    setNotes((prevState) => prevState.filter((el) => id !== el.id));
  };

  const columns = computeColumns({ setRowInfo, setRowExpanded, updateToNotes, removeFromNotes });

  return (
    <div>
      <div>
        <div className="my-6 justify-between w-full">
          <div id="tag-filter" className="flex justify-between">
            <div className="flex flex-row">
              <p>Tags</p>
              <TableFilter
                mapping={mapping}
                containerClassName={classnames(
                  "flex flex-1 items-center text-gray-primary font-light",
                  { "justify-end": false },
                )}
                initialActive="All"
              />
            </div>
          </div>

          <Table
            id="notes-table"
            data={
              filteredNotes.map((n) => ({
                ...n,
                expanded:
                                        rowExpanded && rowInfo && rowInfo.original.id === n.id,
              }))
            }
            columns={columns}
          />
        </div>
      </div>
      <div>
        <button
          className="text-green-primary"
          onClick={() => setShowEditor(!showEditor)}>
          {showEditor ? "Close" : "Show Editor"}
        </button>
        <div className={showEditor ? "" : "hidden"}>
          <NoteEditor
            userId={userId}
            appendToNotes={appendToNotes}
          />
        </div>
      </div>
    </div>
  );
};

export default withStyles(NotesTable);
